export function validateAddress(address) {

  const hasText = /[a-zA-Z]/.test(address)
  const hasNumber = /\d/.test(address)

  if (!hasText) {
    return "missing street"
  }

  if (!hasNumber) {
    return "missing house#"
  }

  return true;
}
